import { render, staticRenderFns } from "./AmountCYPayTypesPage.vue?vue&type=template&id=a1eb9dda&scoped=true"
import script from "./AmountCYPayTypesPage.vue?vue&type=script&lang=js"
export * from "./AmountCYPayTypesPage.vue?vue&type=script&lang=js"
import style0 from "./AmountCYPayTypesPage.vue?vue&type=style&index=0&id=a1eb9dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1eb9dda",
  null
  
)

export default component.exports